<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "JBProposalPremisesGeneralProtection",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>9. Are the premises occupied at night</div>"
					},
					bindTo: ""
				},
				{
					label: "(a) by Proposer?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0PremisesOccupiedByProposerId",
					props: {
						suggest: {
							typeIncludes: "occupiedAtNightByProposer"
						},
						createOptions: {
							type: "occupiedAtNightByProposer",
							dataType: "string"
						}
					}
				},
				{
					label: "(b) by employee or caretaker?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0PremisesOccupiedByEmployeeOrCaretakerId",
					props: {
						suggest: {
							typeIncludes: "occupiedAtNightByEmployeeOrCaretaker"
						},
						createOptions: {
							type: "occupiedAtNightByEmployeeOrCaretaker",
							dataType: "string"
						}
					}
				},
				{
					label:
						"10. Are there any openings leading to cellar or basement from outside the shop? If so, please give details and protection.",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0OpeningLeadToCellarOrBasementId",
					props: {
						suggest: {
							typeIncludes: "openingLeadToCellarOrBasement"
						},
						createOptions: {
							type: "openingLeadToCellarOrBasement",
							dataType: "string"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>11. Give details of the following and how they are protected: </div>"
					},
					bindTo: ""
				},
				{
					label: "(a) each outer door",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0OuterDoorDetailsAndProtectionId",
					props: {
						suggest: {
							typeIncludes: "outerDoorDetailsAndProtection"
						},
						createOptions: {
							type: "outerDoorDetailsAndProtection",
							dataType: "string"
						}
					}
				},
				{
					label: "(b) each inner door",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0InnerDoorDetailsAndProtectionId",
					props: {
						suggest: {
							typeIncludes: "innerDoorDetailsAndProtection"
						},
						createOptions: {
							type: "innerDoorDetailsAndProtection",
							dataType: "string"
						}
					}
				},
				{
					label: "(c) all windows other than Display Windows",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0AllWindowsDetailsAndProtectionId",
					props: {
						suggest: {
							typeIncludes: "allWindowsDetailsAndProtection"
						},
						createOptions: {
							type: "allWindowsDetailsAndProtection",
							dataType: "string"
						}
					}
				},
				{
					label: "(d) all skylights or fanlights or roof openings",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0AllSkylightsDetailsAndProtectionId",
					props: {
						suggest: {
							typeIncludes: "allSkylightsDetailsAndProtection"
						},
						createOptions: {
							type: "allSkylightsDetailsAndProtection",
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
